import React, { useState, useEffect, useMemo } from "react";
import { Container, Background, Hr, Titulo, DivInput, Row, Table, Button } from "./style";
import api from "../../../services/api";
import { Swal } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import Auth from "../../../services/auth";
import { useNavigate } from "react-router-dom";

export default function AtribucaoAulas() {
  const [perfil] = useState(Auth.perfil());
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [professores, setProfessores] = useState([]);
  const [professor, setProfessor] = useState("");
  const [matricula, setMatricula] = useState(0);
  const [consulta, setConsulta] = useState([]);
  const [searchVinculo, setSearchVinculo] = useState("");
  const navigate = useNavigate("");

  useEffect(() => {
    api
      .get(`/${perfil.includes("dir") ? "dir" : "rh"}/contributors?inativo=${false}`)
      .then((response) => {
        setProfessores(response.data.colaboradores);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [perfil]);

  useEffect(() => {
    api
      .get(`/${perfil.includes("dir") ? "dir" : "rh"}/atribucoes-colaborador?matricula=${matricula ?? 0}`)
      .then((response) => {
        setConsulta(response.data.turma_colaborador[0]);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [matricula, perfil, searchVinculo]);

  const atribuicoes = useMemo(() => {
    return consulta?.length > 0
      ? Object.values(
          consulta?.reduce((acc, item) => {
            if (!item.matricula) return acc;

            if (!acc[item.matricula]) {
              acc[item.matricula] = {
                matricula: item.matricula,
                nome: item.professor,
                total: 0,
                dados: [],
              };
            }

            const carga = Number(item.carga) || 0;
            acc[item.matricula].total += carga;
            acc[item.matricula].dados.push(item);

            return acc;
          }, {})
        )
          .sort((a, b) => a.nome.localeCompare(b.nome))
          .filter((c) =>
            professores
              .filter((p) => p.vinculo.includes(searchVinculo))
              .map((p) => p.matricula)
              .includes(c.matricula)
          )
      : [];
  }, [consulta, professores, searchVinculo]);

  useEffect(() => {
    setTotalPages(Math.ceil(atribuicoes.length / 1));
  }, [atribuicoes]);

  const vinculosUnicos =
    professores?.length > 0
      ? professores.reduce((acc, atual) => {
          const jaExiste = acc.some((item) => item.vinculo === atual.vinculo);
          if (!jaExiste) {
            acc.push(atual);
          }
          return acc;
        }, [])
      : [];

  const FormataCentroCusto = (strng) => {
    if (typeof strng == "string") {
      const centro = strng?.split("-")[1];
      return centro.includes("CURSO TÉCNICO")
        ? centro.replaceAll("CURSO TÉCNICO", "")?.trim()
        : centro.includes("CURSO TECNÓLOGO")
        ? centro.replaceAll("CURSO", "")?.trim()
        : centro?.trim();
    }
  };

  return (
    <Background>
      <Container>
        <div className="main">
          <Titulo>Atribuição de Aulas por Professor</Titulo>
          <Hr />
          <Row>
            <DivInput>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  VÍNCULO:
                  <select
                    value={searchVinculo}
                    onChange={(e) => {
                      setSearchVinculo(e.target.value.toUpperCase());
                      setPage(1);
                    }}
                  >
                    <option selected value={""}>
                      TODOS
                    </option>
                    {vinculosUnicos?.map((v, i) => (
                      <option key={i} title={v.vinculo}>
                        {v.vinculo}
                      </option>
                    ))}
                  </select>
                </div>
                <select
                  value={professor}
                  style={{ fontSize: 15, width: 250 }}
                  onChange={(e) => {
                    setProfessor(e.target.value.toUpperCase());
                    setMatricula(e.target[e.target.options.selectedIndex].id);
                    setPage(1);
                  }}
                >
                  <option selected value={0}>
                    {searchVinculo.length > 0 ? "PROFESSORES " + searchVinculo : "TODOS PROFESSORES"}
                  </option>
                  {professores
                    .filter((p) => p.vinculo.includes(searchVinculo))
                    .map((p, i) => (
                      <option key={i} id={p.matricula} title={p.matricula}>
                        {p.nome}
                      </option>
                    ))}
                </select>
              </div>
              <div>
                <Button
                  onClick={() => {
                    navigate("pdf", {
                      state: {
                        atribuicoes: atribuicoes.map((a) => {
                          return {
                            ...a,
                            dados: a.dados.map((d) => {
                              return {
                                ...d,
                                curso: d?.turma?.split("-")[0],
                                centro_custo: FormataCentroCusto(d?.turma),
                              };
                            }),
                          };
                        }),
                      },
                    });
                  }}
                >
                  Carga Horária Semanal
                </Button>
                <Button
                  onClick={() => {
                    navigate("pdf-total", {
                      state: {
                        atribuicoes: atribuicoes.map((a) => {
                          return {
                            matricula: a.matricula,
                            nome: a.nome,
                            total: a.total ? Number(a.total?.toFixed(2)) : 0,
                          };
                        }),
                      },
                    });
                  }}
                >
                  Carga Horária Resumo
                </Button>
              </div>
            </DivInput>
          </Row>
          {atribuicoes?.length > 0 ? (
            atribuicoes?.slice((page - 1) * 1, page * 1)?.map((a, i) => {
              return (
                <Table key={a.matricula}>
                  <h3>{a.nome}</h3>
                  <table style={{ border: 0 }}>
                    <thead>
                      <tr>
                        <th>Curso</th>
                        <th>Centro Custo</th>
                        <th>Componente Curricular</th>
                        <th>Carga Horária</th>
                      </tr>
                    </thead>
                    <tbody>
                      {a.dados.map((d, i) => {
                        const carga = d.carga ? Number(d.carga.toFixed(2)) : 0;
                        return (
                          <tr key={i}>
                            <td data-title="Curso" value={d?.turma?.split("-")[0]}>
                              {d?.turma?.split("-")[0]}
                            </td>
                            <td data-title="Centro Custo" value={FormataCentroCusto(d?.turma)} title={FormataCentroCusto(d?.turma)}>
                              {FormataCentroCusto(d?.turma)}
                            </td>
                            <td data-title="Disciplina" value={d.disciplina} title={d.id_disciplina}>
                              {d.disciplina}
                            </td>
                            <td data-title="Carga Horária" value={carga} title={carga}>
                              {carga}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td style={{ border: 0, backgroundColor: "#fff", padding: 0 }} colSpan={2}></td>
                        <td>
                          <strong>Carga Horária Total:</strong>
                        </td>
                        <td>{a.total ? Number(a.total.toFixed(2)) : 0}</td>
                      </tr>
                    </tbody>
                  </table>
                </Table>
              );
            })
          ) : (
            <table style={{ border: 0, marginTop: 40 }}>
              <thead>
                <tr>
                  <th>Curso</th>
                  <th>Centro Custo</th>
                  <th>Componente Curricular</th>
                  <th>Carga Horária</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>Nenhuma atribuição de aulas encontrada</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
